import { useQuery } from '@tanstack/react-query';
import { fetchSocialLinks } from '../services/socialLinksService';

export function useSocialLinks() {
  return useQuery({
    queryKey: ['socialLinks'],
    queryFn: async () => {
      const data = await fetchSocialLinks();
      return Array.isArray(data?.social_links) ? data.social_links.filter((item) => Number(item?.status) === 1) : [];
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
    retry: 2,
    refetchOnWindowFocus: false,
    refetchOnReconnect: true,
    placeholderData: (previousData) => previousData ?? [],
  });
}
